// PermissionManagerDialog.js - Permission management dialog
import React from 'react';
import { X } from 'lucide-react';
import PermissionManager from '../PermissionManager';

const PermissionManagerDialog = ({
  isOpen,
  onClose,
  className = ''
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 overflow-auto">
      <div className="min-h-screen p-4">
        <div className={`max-w-6xl mx-auto bg-white rounded-lg shadow-xl relative ${className}`}>
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl z-10"
          >
            <X className="w-6 h-6" />
          </button>

          {/* Permission Manager Content */}
          <PermissionManager />
        </div>
      </div>
    </div>
  );
};

export default PermissionManagerDialog;